import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { deleteReels, fetchReelsList } from "../actions/reels";
import { useSelector } from "react-redux";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import { useTranslation } from "react-i18next";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { toast } from "react-toastify";
import { statusRender } from "../utils/cellRenderTable";
import { createDateColumn } from "../utils/agGridDateColumn";

const ReelsList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { reelsList } = useSelector((state) => state.reelsReducer);

  //breadcrumb
  const translateModule = "reels";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  useEffect(() => {
    dispatch(fetchReelsList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.id || !params.data.name) return null;
    return (
      <ButtonColumn
        editLink={`/reels-edit/` + params.data.id}
        deleteItemId={params.data.id}
        deleteItemTitle={`${params.data.name}`}
        value={params}
        submitActionModal={handleSubmitModal}
      />
    );
  };

  const handleSubmitModal = (pageId) => {
    dispatch(deleteReels(pageId));
  };

  const columnDefs = [
    {
      headerName: "Naziv",
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
    },
    {
      headerName: "JWPlayer video",
      field: "videoTargetId",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Video",
      field: "videoName",
      filter: "agSetColumnFilter",
      maxWidth: 300,
    },
    {
      headerName: "Kurs",
      field: "courseName",
      filter: "agSetColumnFilter",
      maxWidth: 300,
    },
    {
      headerName: "Eksterni link",
      field: "externalLink",
      filter: "agTextColumnFilter",
      maxWidth: 300,
    },
    createDateColumn("Datum kreiranja", "createdAt"),
    {
      headerName: "Aktivan",
      field: "active",
      filter: "agSetColumnFilter",
      cellRenderer: statusRender,
      maxWidth: 150,
      // cellClass: "editable-cell",
      valueGetter: (params) => {
        if (params.data?.active === true) return "Aktivan";
        if (params.data?.active === false) return "Neaktivan";
        return "";
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 90,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={`${translateModule}${pageType}`}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        reloadData={() =>
          dispatch(fetchReelsList()).then(() => {
            toast.success("Podaci su uspešno osveženi", {
              theme: "colored",
            });
          })
        }
        rowData={reelsList}
        columnDefs={columnDefs}
        buttonLink={`/reels-add`}
        buttonText={t(`breadcrumb.${translateModule}Add`)}
        gridStateKey="reel-list"
      />
    </Fragment>
  );
};

export default ReelsList;
